import { Typography, Grid, useTheme, useMediaQuery } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { keyframes } from '@mui/system';
import SplashScreen from '../../components/SignUp/SplashScreen';
import SplashScreenMobile from '../../components/SignUp/SplashScreenMobile';
import LanguageSwitcher from '../../components/SignUp/LanguageSwitcher';

const slideInSun = keyframes`
  from {
    transform: translateY(-100%);
  }
  to {
    transform: translateX(0);
  }
`;

function MobileScreen() {
  const { t } = useTranslation();
  const theme = useTheme();
  const currentYear = new Date().getFullYear();
  const isSmallScreen = useMediaQuery(theme.breakpoints.down('sm'));

  return (
    <Grid
      display="flex"
      flexDirection="column"
      alignItems="center"
      minHeight="100vh"
      sx={{
        background: 'linear-gradient(163deg, #FFF 10.13%, #FFF4F0 89.18%)',
        overflow: 'hidden',
        position: 'relative',
        width: '100%',
        height: '100%',
      }}
    >
      <Grid
        mt="36px"
        position="relative"
        display="flex"
        alignItems="center"
        width="100%"
        flexDirection="row-reverse"
      >
        <Grid
          width="100%"
          display="flex"
          justifyContent="center"
          position="absolute"
          sx={{ animation: `${slideInSun} 0.8s ease forwards` }}
        >
          <img src="/assets/icons/logo.svg" alt="logo" height={56} width={56} />
        </Grid>
        <Grid mr={isSmallScreen ? 2 : '140px'} zIndex={1} p="0 0 0 10px">
          <LanguageSwitcher />
        </Grid>
      </Grid>
      <Grid
        container
        item
        xs={isSmallScreen ? 11 : 3}
        display="flex"
        flexDirection="column"
        alignItems="center"
        justifyContent="center"
        gap="32px"
        bgcolor="#fff"
        borderRadius="10px"
        boxShadow={theme.borderStyles.cardBorders}
        border="1px solid #FEE4DB"
        margin="auto"
        minWidth={isSmallScreen ? 358 : 373}
        zIndex={1}
      >
        <Grid
          item
          p="36px"
          gap="11px"
          display="flex"
          flexDirection="column"
          alignItems="center"
          sx={{
            background:
              'linear-gradient(175.46deg, rgba(87, 177, 90, 0.2) -9.81%, rgba(47, 125, 50, 0.2) 96.32%)',
          }}
          width="100%"
          borderRadius="10px 10px 0 0"
        >
          {' '}
          <img
            src="/assets/icons/shield-warning-green.svg"
            alt="bin"
            role="presentation"
            width={65}
          />
        </Grid>
        <Grid gap="1px" display="flex" flexDirection="column" p={isSmallScreen ? 3 : 4}>
          <Typography variant="bodyRegular" textAlign="center" color="primary">
            {t('common.mobileScreenMessage')}
          </Typography>
        </Grid>
      </Grid>
      <Typography variant="caption2Regular" textAlign="center" color="primary" marginBottom="10px">
        {currentYear} ProgressMagic. {t('common.allRightsReserved')}
      </Typography>

      {isSmallScreen ? <SplashScreenMobile /> : <SplashScreen />}
    </Grid>
  );
}

export default MobileScreen;
